import { Component, OnInit } from '@angular/core';
import { SignInModalComponent } from '../sign-in-modal/sign-in-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { Router } from '@angular/router';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import {HomepageService} from '../../../shareModule/services/homepage.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-home-header',
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.scss']
})
export class HomeHeaderComponent implements OnInit {
  isShow: number;
  get_member_type_admin_homepage_response: any;
  member_price_on_off_status: any;

  constructor(private modalService: NgbModal, private local: LocalServiceService, private router: Router, private auth: AuthServiceService, private homepageService: HomepageService, private toastr: ToastrService,) { }

  role = ['admin'];

  ngOnInit(): void {
    // this.get_member_price_on_off_status();
  }

  showLoginModal() {

    let data = this.local.getUser();
    if (data) {
      this.local.removeAdminData();
    }

    //  if(this.local.ifAuthenticated(this.role)){
    //     // this.router.navigate(['/home'])

    //   }else{    
    this.modalService.open(SignInModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title' });
    // }
  }

  onDown(event) {
    // console.log(event.target.value,'-------------down')
    if (event.target.value.length == 8 && event.keyCode != 8) return false;
  }

  onUp(event) {
    // console.log(event.target.value,'--------------up')
    const formData = new FormData();
    formData.append('customerPhone', event.target.value)

    let formDataPrice = new FormData();
    formDataPrice.append('type', '0');

    this.auth.showHideMemberPrice(formDataPrice).subscribe((response: any) => {
      if(response.body == 1) {
        this.auth.get_member_type_admin_homepage(formData).subscribe((response: any) => {
          this.get_member_type_admin_homepage_response = response.body;
          this.isShow = 0;
          this.homepageService.showMemberPrice(this.isShow)
        }, (e) => {
          this.isShow = 1;
          this.homepageService.showMemberPrice(this.isShow)
        })
      } else {
        this.auth.get_member_type_admin_homepage(formData).subscribe((response: any) => {
          this.get_member_type_admin_homepage_response = response.body;
          this.isShow = 0;
        }, (e) => {
          this.isShow = 1;
        })
      }
    }, (e) => {
      this.toastr.error(e.error.message);
    })
  }

  get_member_price_on_off_status() {
    let formDataPrice = new FormData();
    formDataPrice.append('type', '0');

    this.auth.showHideMemberPrice(formDataPrice).subscribe((response: any) => {
      this.member_price_on_off_status = response.body;
      this.homepageService.memberPriceOnOffStatus(this.member_price_on_off_status)
    }, (e) => {
      this.toastr.error(e.error.message);
    })
  }
}
